import React from "react";
import "./aboutme.css";
import { useTranslation } from 'react-i18next';

function Aboutme() {
  const { t } = useTranslation();
  
  return (
    <React.Fragment>
      <div className="aboutme_container">
        <div className="aboutme_left_container">
          <div className="about_me_left_intro_div">
            <p className="aboutme_left_line1">{t('atualmente')}</p>
            <p className="aboutme_left_line2">{t('desenvolvedor')}</p>
            <p className="aboutme_left_line3">{t('em')}</p>
          </div>
        </div>
        <div className="aboutme_right_container">
          <div className="aboutme_right_intro_div">
            <p className="aboutme_intro">
              {t('sobretexto1')}
            </p>
            <br />
            <p className="aboutme_intro">
              {t('sobretexto2')}
            </p>
          </div>
        </div>
      </div>
      <p className="aboutme_left_line2_title">{t('habilidades')}</p>
      <div className="Skills_container">
        <div className="technicalSkills_div">
          <div className="skill_div">
            <h3 className="skill_Name">C# / .NET</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">Angular</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">Ionic</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">TypeScript</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">JavaScript</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">HTML5 / CSS3</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">SQL Server</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">MySQL</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">Git</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">IIS</h3>
          </div>
          <div className="skill_div">
            <h3 className="skill_Name">REST APIs</h3>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default Aboutme;
